<template>
    <div style="margin:auto; text-align:center">
        <div style="margin:auto; text-align:center"><img v-if="showLogo" src="../assets/elvenArchitect-300.png" width="256"></div>

        <div v-if="showProgress" style="margin:auto; text-align:center" >
            <v-progress-circular :indeterminate="true" v-show="showProgress" />
            <div style="margin:auto; text-align:center">{{ $t('site.elvenArchitect.obtainingLink') }}</div>
        </div>
        <a v-if="showButton" @click="getElvenArchitectLink"> {{ $t('site.elvenArchitect.viewCityOnElvenArchitect' )}}</a>

        <v-alert v-if="errorMessage" :value="true" color="error" icon="warning">
            {{errorMessage}}
        </v-alert>




      <div v-if="link" style="margin:auto; text-align:center">
            <font-awesome-icon icon="check" size="3x" style="color:green;"></font-awesome-icon><br/>
            {{ $t('site.elvenArchitect.successMessage') }}<br/>
        <form method="post" target="_blank" action="https://www.elvenarchitect.com/city/planner/"> <!-- action may differ -->
          <input type="hidden" name="import" :value="link" /> <!-- data value must be base64 encoded -->
          <button type="submit"><a>Click Here</a></button>
        </form>


        <br/><span style="color:#555555;font-size:90%;"> <elv-refresh-user-icon :player="player"></elv-refresh-user-icon> {{ $t('site.elvenArchitect.clickToGetCurrentCity') }}</span>
        </div>

        <v-snackbar
                :timeout="timeout"
                :color="color"
                :multi-line="mode === 'multi-line'"
                :vertical="mode === 'vertical'"
                v-model="snackbar"
        >
            {{ errorMessage }}
            <v-btn dark flat @click.native="snackbar = false">{{ $t('site.common.close') }}</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import axios from 'axios';
    import ElvRefreshUserIcon from "@/components/ElvRefreshUserIcon";
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    export default {
        components: {ElvRefreshUserIcon, FontAwesomeIcon},
        name: 'elv-architect-redirector',
        props: {
            'player': {required:true},
            'showLogo': {required: false, default: false}
        },
        data () {
            return {
                link: null,
                showProgress: false,
                showButton: true,
                errorMessage: "",
                snackbar: false,
                color: '',
                mode: '',
                timeout: 6000,
                snackText: ''
            }
        },
        created() {
            Event.$on("playerRefreshed", (data) => {
                if( data.playerId === this.player.playerId ) {
                    if( !this.showButton ) {
                        this.getElvenArchitectLink();
                    }
                } else {
                    console.log("ElvArchitectRedirector: Ignoring refresh event as it's for different player: ", data);
                }
            });
        },
        methods: {
            // getArchitectPayload: function() {
            //   axios.get(`/api/player/${this.player.server}/${this.player.playerId}/elvenarchitect`).then( (response) => {
            //     this.snackbar = true;
            //     this.showProgress = false;
            //     //console.log("ELVEN ARCH RESPONSE", response.data);
            //     if( _.get(response, "data.status") === "ok" ) {
            //       this.link = response.data.link;
            //     } else {
            //       this.errorMessage = _.get(response, "data.message") || "Unable to import city at this time";
            //     }
            //     this.$ga.event('ElvenArchitect', 'LinkCreated', self.server, self.playerId);
            //   }).catch( (err) => {
            //     this.showProgress = false;
            //     this.color = "error";
            //     this.errorMessage = _.get(err.response, "data.message") || "Unable to create import link at this time. Please try again later.";
            //     this.$ga.event('ElvenArchitect', 'LinkFailed', self.server, self.playerId);
            //   });
            // },
            getElvenArchitectLink: function() {
                let self = this;
                this.showProgress = true;
                this.showButton = false;
                this.link = "";
                axios.get(`/api/player/${this.player.server}/${this.player.playerId}/elvenarchitect`).then( (response) => {
                    this.snackbar = true;
                    this.showProgress = false;
                    //console.log("ELVEN ARCH RESPONSE", response.data);
                    if( _.get(response, "data") ) {
                        this.link = btoa(JSON.stringify(response.data));
                    } else {
                        this.errorMessage = _.get(response, "data.message") || "Unable to import city at this time";
                    }
                    this.$ga.event('ElvenArchitect', 'LinkCreated', self.server, self.playerId);
                }).catch( (err) => {
                    this.showProgress = false;
                    this.color = "error";
                    this.errorMessage = _.get(err.response, "data.message") || "Unable to create import link at this time. Please try again later.";
                    this.$ga.event('ElvenArchitect', 'LinkFailed', self.server, self.playerId);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ElvArchitectRedirector.vue